import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
function NotFound() {
    return (
        <div className="mx-auto prose mt-20 pb-24 text-center prose-darkgreen">
            <h1 className="mb-0 text-8xl">404</h1>
            <p className="lead">Page not found.</p>
            <p className="text-sm">
                The page you are looking for doesn't exist.
            </p>
            <Button asChild className="not-prose mx-auto">
                <Link to="/">Back To Homepage</Link>
            </Button>
        </div>
    );
}

export default NotFound;
